import { Link } from "react-router-dom";
import { ArrowLeft, RotateCcw } from "lucide-react";
import { brand } from "@/config/brand";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="flex min-h-screen flex-col items-center justify-center bg-base px-6 text-center">
      <div className="w-full max-w-md rounded-[10px] border border-black/10 bg-white p-10 shadow-[0_30px_70px_-40px_rgba(0,0,0,0.4)]">
        <img src={brand.logo_url} alt={brand.brand_name} className="mx-auto mb-8 h-10 w-auto object-contain" />
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-black/15">
          <RotateCcw className="text-black" size={24} />
        </div>
        <h1 data-testid="payment-cancel-heading" className="mt-6 text-2xl font-black tracking-tight">Checkout canceled</h1>
        <p className="mt-3 text-sm font-light leading-relaxed text-black/60">
          No charge was made. Whenever you're ready, you can pick a plan and start growing.
        </p>
        <Link
          data-testid="payment-back-pricing-link"
          to="/#pricing"
          className="mt-8 inline-flex items-center justify-center gap-2 rounded-[10px] bg-black px-6 py-3.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
        >
          <ArrowLeft size={15} /> Back to pricing
        </Link>
      </div>
    </div>
  );
}
